import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=11923a46&scoped=true"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=11923a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11923a46",
  null
  
)

export default component.exports